<template>
  <div class="page">
    <navigationBar contentText="我的心愿单"></navigationBar>
    <!-- 背景圆 -->
    <!-- <div class="collect_bg-cricle" v-if='noData == 1'></div> -->
    <div class="bg-cricle" v-if="noData == 1"></div>
    <div class="wrap">
      <!-- 收藏列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        @load="lower"
        class="scroll-view"
        v-if="noData == 1"
        :offset="50"
      >
        <!-- 列表 -->
        <div class="list">
          <div v-for="(item, index) in collectData" :key="item.id">
            <productInfo
              @fatherMethod="fatherMethod"
              :product="item"
              :checkedArr="checkgroup[index]"
            ></productInfo>
          </div>
        </div>
      </van-list>
      <!-- 删除操作 -->
      <div v-if="noData == 1" class="handle">
        <div class="addCarthandle">
          <div class="allselect" @click="allselectClick">
            <img class="radio" v-if="!allselect" :src="icon_check" />
            <img class="radio" v-if="allselect" :src="icon_checked" />
            <span>全选</span>
          </div>
          <div class="hasSelected">
            已选中
            <span>{{ allNumber }}</span>
            件商品
          </div>
          <div class="delect" @click="addCart">加入购物车</div>
        </div>
      </div>
      <!-- 没有收藏 -->
      <div v-if="noData == 0" class="no_collect">
        <div class="bg-cricle no-fixed"></div>
        <img :src="no_collect" />
        <div>心愿单还是空的哦!</div>
      </div>
      <!-- 猜你喜欢 -->
      <recommend v-if="noData == 0"></recommend>
    </div>
  </div>
</template>

<script>
  import { get_collect_list, add_multi, del_collect } from "../../api/collect";
  import Vue from 'vue'
  import { List, Dialog } from 'vant'
  import ProductInfo from './components/index'
  import icon_check from '@/assets/images/my/icon_check.png'
  import icon_checked from '@/assets/images/my/icon_checked.png'
  import no_collect from '@/assets/images/my/no_collect.png'
  import Recommend from '@/components/recommend/index'

  import Toast from '@/components/Toast'
  Vue.use(List).use(Dialog)
  export default {
    components: {
      ProductInfo,
      Recommend
    },
    data () {
      return {
        collectData: [],
        noData: -1,
        checkgroup: [],
        allselect: false,
        allNumber: 0,
        calculateHeight: '100vh',
        isLoading: false,
        loading: false,
        finished: false,
        loadOver: false,
        pageNum: 1,
        pageSize: 6
      }
    },
    computed: {
      icon_check () {
        return icon_check
      },
      icon_checked () {
        return icon_checked
      },
      no_collect () {
        return no_collect
      }
    },
    mounted () {
      this.getCollect();
    },
    methods: {
      lower () {
        console.log(this.isLoading);
        if (this.isLoading) {
          return
        }
        this.getCollect();
      },
      getCollect () {
        if (this.loadOver) {
          return false;
        }
        this.isLoading = true
        let parmas = {
          "sort": "id+desc",
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        get_collect_list(parmas).then(res => {
          let that = this;
          this.loading = false
          setTimeout(function () {
            that.isLoading = false
          }, 300)
          let list = res.records.map(item => ({
            id: item.id,
            productInfoSimpleVo: this.productListModel(item.productInfoSimpleVo),
            likeProductSimpleVoList: item.likeProductSimpleVoList.map(i => this.productListModel(i))
          }))
          this.collectData = this.collectData.concat(list)
          this.pageNum = this.pageNum + 1
          if (this.collectData.length >= res.total) {
            this.loadOver = true
            this.finished = true
          } else {
            this.loadOver = false
            this.finished = false
          }
          if (this.collectData.length != 0) {
            this.noData = 1
          } else {
            this.noData = 0
          }
          // checkgroup
          let group = [];
          for (let k in this.collectData) {
            // let groupArr = [];
            let sellout = false;
            if (this.collectData[k].productInfoSimpleVo.productInfo.status == 1 && this.collectData[k].productInfoSimpleVo.productInfo.saleStatus == 1) {
              sellout = false;
            } else {
              sellout = true;
            }
            let productCheck = {
              id: this.collectData[k].productInfoSimpleVo.productSkuId,
              productType: this.collectData[k].productInfoSimpleVo.productInfo.type,
              productId: this.collectData[k].productInfoSimpleVo.productId,
              quantity: 1,
              sellout: sellout,
              val: false
            }
            let likeArr = [];
            for (let n in this.collectData[k].likeProductSimpleVoList) {
              let sellout2 = false;
              if (this.collectData[k].likeProductSimpleVoList[n].productInfo.status == 1 && this.collectData[k].likeProductSimpleVoList[n].productInfo.saleStatus == 1) {
                sellout2 = false;
              } else {
                sellout2 = true;
              }
              likeArr.push({
                id: this.collectData[k].likeProductSimpleVoList[n].productSkuId,
                productType: this.collectData[k].likeProductSimpleVoList[n].productInfo.type,
                productId: this.collectData[k].likeProductSimpleVoList[n].productId,
                quantity: 1,
                sellout: sellout2,
                val: false
              })
            }
            group.push({ productCheck: productCheck, likeArr: likeArr })
            this.checkgroup = group
          }
        })
      },
      fatherMethod (e, method) {
        if (method == 'onMyEvent') {
          this.onMyEvent(e)
        }
        if (method == 'onMyEvent2') {
          this.onMyEvent2(e)
        }
        if (method == 'del_event') {
          this.del_event(e)
        }
      },
      onMyEvent (e) {
        let group = this.checkgroup;
        let alltrue = true;
        for (let j in group) {
          if (group[j].productCheck.id == e.id) {
            group[j].productCheck.val = e.val
          }
          if (group[j].productCheck.val == false) {
            alltrue = false;
            this.allselect = false
          }
        }
        if (alltrue) {
          this.allselect = true
        }
        this.checkgroup = group
        this.checkNumber();
      },
      onMyEvent2 (e) {
        let group = this.checkgroup;
        for (let j in group) {
          for (let k in group[j].likeArr) {
            if (group[j].likeArr[k].id == e.id) {
              group[j].likeArr[k].val = e.val
            }
          }
        }
        this.checkgroup = group
        this.checkNumber();
      },
      del_event (e) {
        let parmas = {
          "idList": [e.id]
        }
        Dialog.confirm({
          title: '',
          message: '确定删除该商品？'
        }).then(() => {
          // on confirm
          del_collect(parmas).then(res => {
            this.isLoading = false
            this.loading = false
            this.loadOver = false
            this.finished = false
            this.pageNum = 1
            this.pageSize = 6
            this.collectData = []
            this.getCollect();
          })
        }).catch(() => {
          // on cancel
        });
      },
      allselectClick () {
        this.allselect = !this.allselect
        let group = this.checkgroup;
        for (let i in group) {
          if (this.allselect) {
            if (group[i].productCheck.sellout) {
              group[i].productCheck.val = false;
            } else {
              group[i].productCheck.val = true;
            }
          } else {
            group[i].productCheck.val = this.allselect;
          }
        }
        this.checkgroup = group
        this.checkNumber();
      },
      checkNumber () {
        let number = 0;
        for (let i in this.checkgroup) {
          if (this.checkgroup[i].productCheck.val) {
            number += 1;
          }
          for (let j in this.checkgroup[i].likeArr) {
            if (this.checkgroup[i].likeArr[j].val) {
              number += 1;
            }
          }
        }
        this.allNumber = number
      },
      addCart () {
        let parmas = [];
        for (let i in this.checkgroup) {
          if (this.checkgroup[i].productCheck.val) {
            parmas.push({
              productType: this.checkgroup[i].productCheck.productType,
              productId: this.checkgroup[i].productCheck.productId,
              productSkuId: this.checkgroup[i].productCheck.id,
              quantity: 1
            })
          }
          for (let j in this.checkgroup[i].likeArr) {
            if (this.checkgroup[i].likeArr[j].val) {
              parmas.push({
                productType: this.checkgroup[i].likeArr[j].productType,
                productId: this.checkgroup[i].likeArr[j].productId,
                productSkuId: this.checkgroup[i].likeArr[j].id,
                quantity: 1
              })
            }
          }
        }
        add_multi({ 'cartAddReqList': parmas }).then(res => {
          Toast({
            message: '添加购物车成功!'
          })
          this.allselect = false
          this.isLoading = false
          this.loading = false
          this.loadOver = false
          this.finished = false
          this.pageNum = 1
          this.pageSize = 6
          this.collectData = []
          this.getCollect();
        }).catch(err => {
          console.log(err)
          Toast({
            message: '添加购物车失败!'
          })
        })
      },
      productListModel (item) {
        return {
          productInfo: {
            mainImage: item.productSimpleVo.mainImage,
            brandName: item.productSimpleVo.brandName,
            title: item.productSkuSimpleVo.title,
            spec1: item.productSkuSimpleVo.spec1,
            spec2: item.productSkuSimpleVo.spec2,
            spec3: item.productSkuSimpleVo.spec3,
            param: item.productSkuSimpleVo.param,
            type: item.productSkuSimpleVo.type,
            description: item.productSkuSimpleVo.description,
            saleStatus: item.productSkuSimpleVo.saleStatus,
            status: item.productSkuSimpleVo.status
          },
          price: item.productSkuSimpleVo.price,
          priceHkd: item.productSkuSimpleVo.priceHkd,
          productSkuId: item.productSkuSimpleVo.productSkuId,
          productId: item.productSkuSimpleVo.productId
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  // .page{
  //   background: #f7f7f7;
  //   height: 100%;
  // }
  .collect_bg-cricle {
    width: 14rem;
    height: 14rem;
    position: fixed;
    top: -9.6rem;
    left: 50%;
    transform: translateX(-50%);
    background: #ba1621;
    border-radius: 50%;
    z-index: -1;
  }
  .bg {
    width: 100%;
    height: 3.2rem;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
  }
  .wrap {
    width: 100%;
    height: 100%;
    //   position: fixed;
    //   top: 0;
    //   left: 0;
    bottom: env(safe-area-inset-bottom);
    box-sizing: border-box;
    &::-webkit-scrollbar {
      width: 0;
    }
    //   background: #f7f7f7;
  }
  .wrap .scroll-view {
    box-sizing: border-box;
    height: calc(100% - 1rem);
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  // .list{
  //   height: 100%;
  // }
  .handle {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 7.5rem;
    height: 1rem;
    background: #fff;
    //   width: 100%;
    z-index: 999;
    display: flex;
    /* padding: 0 20rpx; */
    /* box-sizing: border-box; */
    justify-content: space-between;
    align-items: center;
    border-top: 0.01rem solid #f7f7f7;
    padding-bottom: env(safe-area-inset-bottom);
    /* margin-bottom: env(safe-area-inset-bottom); */
  }
  .addCarthandle {
    width: 7.1rem;
    height: 1rem;
    z-index: 999;
    display: flex;
    padding: 0 0.2rem;
    /* box-sizing: border-box; */
    justify-content: space-between;
    align-items: center;
    border-top: 0.01rem solid #f7f7f7;
  }
  .delect {
    width: 2.44rem;
    height: 0.77rem;
    border-radius: 0.77rem;
    background: #bc121b;
    text-align: center;
    line-height: 0.77rem;
    font-size: 0.3rem;
    color: #fff;
  }
  .radio {
    width: 0.39rem;
    height: 0.39rem;
  }
  .allselect {
    display: flex;
    align-items: center;
  }
  .allselect span {
    font-size: 0.26rem;
    color: #6f6f6f;
    margin-left: 0.1rem;
  }
  .hasSelected {
    font-size: 0.26rem;
    color: #000000;
  }
  .hasSelected span {
    color: #ba1622;
    margin: 0.05rem;
  }

  .no-fixed {
    position: absolute;
    z-index: 0;
    // top: -0.45rem;
    top: -1.1rem;
    margin-top: 0;
  }

  .no_collect {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 4.08rem;
    position: relative;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
  .no_collect img {
    width: 1.12rem;
    height: 1.12rem;
    flex-shrink: 0;
    //   margin-top: 1.14rem;
    //   margin-bottom: 1.7rem;
    margin-top: 0.8rem;
    z-index: 2;
  }
  .no_collect div {
    font-size: 0.26rem;
    color: #ffffff;
    text-align: center;
    z-index: 2;
    margin-top: 0.3rem;
  }
</style>
